



























































































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import * as signalR from "@microsoft/signalr";
import HelpContent from '../HelpContent.vue';
import ChunkUploader from '@/components/ChunkUploader/ChunkUploader.vue';

/*
export type Uploader = Vue & {
    active: boolean;
    clear: () => boolean;
}
*/

@Component({
    components: {
        HelpContent,
        ChunkUploader
    }
})
    

export default class DocumentsZipUploader extends Vue {
    fileTypeAllowed: boolean = true;
    uploadPerc: number = 0;
    importProcessList = [];
    showStep1 = false;
    showStep2 = false;
    fileTypeSelected: string = null;
    fileTypeOptions: any = null;
    chunkEnabled: boolean = true;
    chunkSize: number = 300;
    loading: boolean = false;
    tooltipShow: boolean = true;
    clientId: string = this.$store.state.user.Username + '_' + (new Date()).getTime();
    connection: any;
    modal_helpDocumentUploader: string = "modal-helpDocumentUploader";
    general: any;
    /*@Watch('firstResponseFile')
    fileResponse(fileNew: any, fileOld: any) {
        if (fileNew && fileNew.processId) this.importFile();
    }*/
    beforeDestroy() {
        this.connection.stop();
    }
    mounted() {
        this.general = General;
        this.loadFileType();
        this.reset();
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            if (isJustShown) this.tooltipShow = false;

            //console.log('isJustShown:', isJustShown)
        })
        this.fileTypeSelected = 'PDS';
    }
    reset() {
        if (this.connection) {
            this.connection.stop();
            
        }
        this.showStep1 = false;
        this.showStep2 = false;
        this.fileTypeAllowed = true;
        this.importProcessList = [];
        this.fileTypeSelected = null;
        this.uploadPerc = 0;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(General.GetApiUrl('/message'))
            .build();
        let app = this;
        this.connection.on("status", data => {
            var dataParsed = JSON.parse(data);
            app.importProcessList = dataParsed;
            
        });
        
        this.$nextTick(() => {
            (this.$refs.ChunkUploaderRef as ChunkUploader).reset();
        });

        this.fileTypeSelected = 'PDS';



    }
    getSize(sizeByte: number) {
        let scale: string = 'Kb';
        let sizeKb: number = (sizeByte / 1024);
        let sizeMb: number = (sizeKb / 1024);
        let sizeGb: number = (sizeMb / 1024);
        let outputSize: string = sizeKb.toFixed(0);
        if (sizeKb > 1000) {
            scale = 'Mb';
            outputSize = sizeMb.toFixed(1);
        }
        if (sizeMb > 1000) {
            scale = 'Gb';
            outputSize = sizeGb.toFixed(1);
        }
        return outputSize + ' ' + scale;
    }
    forceCancel(process: any) {
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/process/ForceEndTask?user=' + this.$store.state.user.Username + '&processId=' + process.ProcessId),
            withCredentials: true,
            responseType: 'json'
        })
            .then(({ data }) => {
                /*
                 app.resultsItems.resultPage = app.resultsItems.resultPage.concat(data.listPage);
                 app.resultsItems.total = data.total;
                 app.firstSearch = true;
                 app.page += 1;

                 app.showLoading = false;
                 */
            });
        console.log("cancella task " + process.ProcessId)
    }


    importArchive(processId: any) {
        
        this.connection.start()
        this.showStep2 = true;
        this.showStep1 = true;
        this.uploadPerc = 100;
        let app: any = this;
        setTimeout(()=>{
            axios({
                method: 'post',
                url: General.GetApiUrl('/api/document/ImportArchiveProcess?processId=' + processId + '&documentType=' + this.fileTypeSelected),
                withCredentials: true,
                responseType: 'json'
            }).then((response) => {
                // Gestione della risposta di successo
                console.log('ImportArchiveProcess completato con successo:', response.data);
            }).catch((error) => {
                // Gestione degli errori
                console.error('Errore durante ImportArchiveProcess:', error);
                
                let errorMessage = this.$t('PRODUCT.ZIP_ERROR');
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                app.$fire({
                    title: "Error",
                    text: errorMessage,
                    type: "error"
                });
            });
        }, 1000);
    }
    get isAllProcessEnd(): boolean {
        for (let item of this.importProcessList) {
            if (item.Status == 'complete' || item.Status == 'error') return true;
        }
        return false;
    }
    updateArchiveImportProgress(e: any) {
        
        if (e > 0)
            this.fileTypeAllowed = false;
        this.uploadPerc = e;
    }
    readProcessError(errors: string) {
        let errorList = errors.split('|');
        return errorList;
    }
    loadFileType() {
      
        this.fileTypeOptions = this.convertFileTypeToSelect([{ "name": "PDS", "value": 1 }]);
    }
  
    convertFileTypeToSelect(data: any) {
        let outputData = new Array();
        data.forEach(function (item: any) {
            outputData.push({
                value: item.name,
                text: item.name
            });
        });
        return outputData;
    };
    get firstResponseFile() {
      
        return { processId: '' };
    }






    languagesList = [];
    public get languagesFields() : Array<Object> { 
        return [
        {
            key: 'code',
            label:  this.$t('PRODUCT.ISO_CODE'),
            sortable: true
        },
        {
            key: 'name',
            label:  this.$t('PRODUCT.NAME'),
            sortable: true
        }
    ]};
    languagesFilter: string = null;
    countriesList = [];
    public get countriesFields() : Array<Object> {
        return [
        {
            key: 'code',
            label: this.$t('PRODUCT.CODE'),
            sortable: true
        },
        {
            key: 'name',
            label: this.$t('PRODUCT.NAME'),
            sortable: true
        }
    ];
    }
    
    countriesFilter: string = null;

    async showLanguagesCode() {
        if (this.languagesList.length == 0) {
            await axios({
                method: 'get',
                url: General.GetApiUrl('/api/culture/GetLanguages/?emptyLanguagesPolicy=0'),
                responseType: 'json'
            }).then(({ data }) => {

                data.forEach(key =>
                    this.languagesList.push({
                        code: key.code.toUpperCase(),
                        name: key.name
                    })
                );
            })
        }
    }

    openInstructions() {
        this.tooltipShow = false;
    }

    async showCountriesCode() {
        if (this.countriesList.length == 0) {
            await axios({
                method: 'get',
                url: General.GetApiUrl('/api/culture/GetCountries/?emptyCountriesPolicy=0&type=COUNTRY_AUTHORITY'),
                withCredentials: true,
                responseType: 'json'
            }).then(({ data }) => {

                data.forEach(key =>
                    this.countriesList.push({
                        code: key.code.toUpperCase(),
                        name: key.name
                    })
                );
            })
        }
    }

}
